// ponytail: this whole worktree IS the prototype shell, so the flag is a hardcoded
// constant — zero env setup needed to run. Flip to `false` to point the app at a real
// backend again (you'd then also need the usual VITE_* env vars).
export const IS_PROTOTYPE = true

// All-access staff permission mask (lifted verbatim from web/core/src/mocks/me.mock.js).
// `sites: { '*': ... }` = universal site access; corporate bits grant brand controls.
// Used to override any `staffUserPermissions` field so the fake user sees the full app.
export const ALL_ACCESS_PERMISSIONS = JSON.stringify({
  access: '2376844875427930127806318510080',
  corporate: '159723975628756904588584603877376',
  sites: { '*': '162259276829213363391578010288127' },
})

// Shared gate credentials for the hosted prototype.
// ponytail: this is a CLIENT-SIDE speed bump, not real auth — the bundle is public, so the
// password is readable by anyone who looks and the flag is just localStorage. It keeps
// randoms/crawlers out of a shared link, nothing more. For real protection put Cloudflare
// Access in front of the Pages project (edge auth, no code).
export const PROTOTYPE_LOGIN = { email: 'product@hapana.com', password: 'Hapana-123' }

const PROTOTYPE_AUTH_KEY = 'prototypeAuthed'

export const isPrototypeAuthed = () => {
  try {
    return localStorage.getItem(PROTOTYPE_AUTH_KEY) === 'true'
  } catch (_) {
    return false
  }
}

export const setPrototypeAuthed = () => {
  try {
    localStorage.setItem(PROTOTYPE_AUTH_KEY, 'true')
  } catch (_) {
    // ignore — a non-persistent gate is acceptable for a prototype
  }
}
